"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _views = require("./../site-selector-components/views");

var CurrentSite = _react["default"].forwardRef(function (_ref, menuBtnRef) {
  var isMobile = _ref.isMobile,
      onMenuBtnClick = _ref.onMenuBtnClick,
      isMenuOpen = _ref.isMenuOpen,
      currentSite = _ref.currentSite;
  return /*#__PURE__*/_react["default"].createElement(_views.MenuContainer, (0, _extends2["default"])({
    isMobile: isMobile,
    onClick: onMenuBtnClick,
    ref: menuBtnRef,
    "aria-owns": isMenuOpen ? 'navigation-site-selector-menu' : undefined,
    "aria-haspopup": "true"
  }, (0, _taggingHelper.getDataProperty)({
    dataElementLocation: _taggingHelper.DataElementLocations.NAV,
    dataElementLabel: 'navigation-site-selector-menu',
    dataElementId: "navigation-site-selector-menu",
    dataElementType: _taggingHelper.DataElementTypes.DROPDOWN
  })), /*#__PURE__*/_react["default"].createElement(_views.SiteThumbnail, {
    screenshot: currentSite.screenshot,
    className: "mr-3"
  }), /*#__PURE__*/_react["default"].createElement(_views.SiteName, {
    className: "mr-2"
  }, currentSite.name), isMenuOpen ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null));
});

CurrentSite.propTypes = {
  isMobile: _propTypes["default"].bool,
  onMenuBtnClick: _propTypes["default"].func,
  isMenuOpen: _propTypes["default"].bool,
  currentSite: _propTypes["default"].object
};
var _default = CurrentSite;
exports["default"] = _default;